import React, { Component } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Storage from "react-native-storage";
import i18n from "i18n-react";

// FontAwesome
import "config/FontAwesome";

import {
  AppSettings,
  APIHandler,
  AppRouter,
  locales,
  StorageHandler,
  SessionHandler,
  CookieWarning,
} from "C4";
import { storageKeys, language, userKeys } from "settings";

import "normalize.css/normalize.css";
import "./assets/styles/styles.scss";

const { cookieEnabled } = window.navigator;

const exportObject = cookieEnabled
  ? new Storage({
      storageBackend: cookieEnabled ? window.localStorage : {},
      defaultExpires: 1000 * 3600 * 24, // 1 day = (1000 * 3600 * 24 milliseconds), null = never expire
      enableCache: true,
      sync: {
        // TODO: Handle exiration of data (Reload data with new API Calls)
      },
    })
  : {};

export default exportObject;

i18n.setTexts(locales.en); //  setTexts i18n based on localstorage lang fix both on page load
if (cookieEnabled) {
  // Check if language is already set, proceed said language.
  StorageHandler.exists(storageKeys.lang).then((languageExists) => {
    if (languageExists) {
      StorageHandler.load(storageKeys.lang).then((res) => {
        i18n.setTexts(locales[res.langFile]);
      });
    } else {
      i18n.setTexts(locales.en);
      StorageHandler.save(storageKeys.lang, {
        country: "English",
        code: "US",
        langFile: "en",
      });

      // TODO refactor
      const paramsUri = new URLSearchParams(window.location.search);
      const appIdUri = paramsUri.get("appId");
      if (appIdUri) {
        StorageHandler.save(storageKeys.appId, appIdUri, 86400000 * 365);
        window.appId = appIdUri;
        window.location.reload();
      } else if (window.location.hostname === "renotahoe.travelnevada.com") {
        StorageHandler.save(storageKeys.appId, 1388, 86400000 * 365);
        window.appId = 1388;
        window.location.reload();
      } else if (window.location.hostname === "visitspc.thesource.travel") {
        StorageHandler.save(storageKeys.appId, 1392, 86400000 * 365);
        window.appId = 1392;
        window.location.reload();
      } else if (window.location.hostname === "newregister.thesource.travel") {
        StorageHandler.save(storageKeys.appId, 1377, 86400000 * 365);
        window.appId = 1377;
        window.location.reload();
      } else if (
        window.location.hostname === "treasureisland.thesource.travel"
      ) {
        StorageHandler.save(storageKeys.appId, 1393, 86400000 * 365);
        window.appId = 1393;
        window.location.reload();
      } else if (window.location.hostname === "micro.thesource.travel") {
        const userInput = window.prompt("Please enter your app id", "1");
        if (userInput !== null) {
          StorageHandler.save(storageKeys.appId, userInput, 86400000 * 365);
          window.appId = userInput;
          window.location.reload();
        }
      } else if (window.location.hostname !== "localhost") {
        APIHandler.getIdByDomain(window.location.hostname).then((res) => {
          if (res) {
            StorageHandler.save(storageKeys.appId, res, 86400000 * 365);
            window.appId = res;

            APIHandler.getLanguage(window.location.hostname).then((langD) => {
              if (langD && langD !== "en_US") {
                const langCode = langD.split("_")[0].toLowerCase();
                StorageHandler.save(storageKeys.lang, {
                  country: language[langCode],
                  code: langCode,
                  langFile: langCode,
                });
                i18n.setTexts(locales[langCode]);
                window.location.reload();
              } else {
                window.location.reload();
              }
            });
          }
        });
      } else {
        const userInput = window.prompt("Please enter your app id", "1");
        if (userInput !== null) {
          StorageHandler.save(storageKeys.appId, userInput, 86400000 * 365);
          window.appId = userInput;
          window.location.reload();
        }
      }
    }
  });
  StorageHandler.load("askedMobile").then((askedBefore) => {
    ReactDOM.render(
      <App askedBefore={askedBefore} />,
      document.getElementById("root")
    );
  });
}

class App extends Component {
  constructor(props) {
    super(props);

    const mobileRegex = new RegExp(
      "Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini",
      "i"
    );
    const mobilePathRegex = new RegExp("mobile", "i");

    this.state = {
      onMobile:
        mobileRegex.test(window.navigator.userAgent) &&
        !mobilePathRegex.test(window.location.href),
      askedBefore: this.props.askedBefore,
      loading: true,
    };
  }

  componentDidMount() {
    this.setLoader();
  }

  setLoader() {
    SessionHandler();
    AppSettings().then((res) => {
      if (res) {
        this.loadParentData();
      }
    });
  }

  async loadParentData() {
    this.setState({ loading: true });
    const params = new URLSearchParams(window.location.search);
    const appId = params.get("appId");
    if (appId) {
      const { app } = (await APIHandler.getAppInfo(appId)) || { app: [{}] };
      StorageHandler.save(storageKeys.parentApp, app);
      this.setState({ loading: false });
    } else {
      StorageHandler.load(storageKeys.appInfo).then(async (res) => {
        if (
          res &&
          res.microLearningPartner &&
          res.microLearningPartner !== null
        ) {
          console.log(res.microLearningPartner);
          // If redirect to parent is enabled, redir to travpromobile.com
          if (res.redirectToPartnerUrl) {
            window.location.href = res.redirectToPartnerUrl;
          }

          const { app } = (await APIHandler.getAppInfo(
            res.microLearningPartner
          )) || { app: [{}] };
          StorageHandler.save(storageKeys.parentApp, app);
          this.setState({ loading: false });
        } else {
          // If redirect to parent is enabled, redir to travpromobile.com
          if (res.redirectToPartnerUrl) {
            window.location.href = res.redirectToPartnerUrl;
          }

          // No parent
          this.setState({ loading: false });
        }
      });
    }
  }

  render() {
    const { onMobile, askedBefore, loading } = this.state;
    const params = new URLSearchParams(window.location.search);
    let header = true;
    if (params.get("header") === "false") {
      header = false;
    }

    const setAsked = () => {
      // this.setState({ askedBefore: true });
      // StorageHandler.save('askedMobile', true);
      // TODO on mobile
      window.history.back();
    };

    return (
      <div className="container__router">
        {!cookieEnabled && <CookieWarning />}
        {loading && (
          <div className="appLoader">
            <FontAwesomeIcon icon={["fas", "circle-notch"]} spin />
          </div>
        )}
        {!loading && <AppRouter />}
      </div>
    );
  }
}

App.propTypes = {
  askedBefore: PropTypes.bool.isRequired,
};
